import type { StorageResponsePayload } from "@swiggy-private/native-bridge";
import { deleteFromStorage, getFromStorage, saveToStorage } from "./storage";
import { CROSS_SELL_FREQ_TTL_MS } from "../constants/menu";
import { WebStorageLocation } from "../types";
export const isFrequencyCappedWithTableId = async (
    key: string,
    tableId: string,
    timeOffset: number,
): Promise<boolean> => {
    try {
        const response = await getFromStorage(key);
        const dataStr = response?.data[key];
        const data = JSON.parse(dataStr ?? "{}");
        const frequencyTime = data.value || 0;
        const savedTableId = data.tableId || "";
        if (frequencyTime == null) {
            return await Promise.resolve(false);
        }

        if (Date.now() - Number(frequencyTime) < timeOffset && savedTableId === tableId) {
            return await Promise.resolve(true);
        } else {
            deleteFromStorage(key);
        }

        return await Promise.resolve(false);
    } catch (_) {
        return Promise.resolve(false);
    }
};

export const updateFrequencyCappingWithTableId = async (
    key: string,
    tableId: string,
): Promise<StorageResponsePayload | undefined> => {
    const payload = JSON.stringify({
        tableId,
        value: String(Date.now()),
    });
    const response = await saveToStorage(key, payload);
    return response;
};

export const isFrequencyCappedForCartTooltip = async (key: string) => {
    try {
        const response = await getFromStorage(key, WebStorageLocation.SESSION);
        return response?.data[key] === "true";
    } catch (_) {
        return false;
    }
};

export const updateFrequencyCappingForCartTooltip = async (key: string) => {
    try {
        await saveToStorage(key, "true", WebStorageLocation.SESSION);
    } catch (_) {}
};

export const getCrossSellShownItemIds = async (key: string, tableId: string): Promise<string[]> => {
    if (!tableId) return [];
    try {
        const response = await getFromStorage(key);
        const data = JSON.parse(response?.data[key] ?? "{}");
        const isExpired = Date.now() - Number(data.updatedAt ?? 0) >= CROSS_SELL_FREQ_TTL_MS;
        if (data.tableId !== tableId || isExpired) {
            deleteFromStorage(key);
            return [];
        }
        return Array.isArray(data.shownItemIds) ? data.shownItemIds : [];
    } catch (_) {
        return [];
    }
};

export const updateCrossSellShownItemIds = async (
    key: string,
    tableId: string,
    shownItemIds: string[],
): Promise<void> => {
    if (!tableId) return;
    await saveToStorage(key, JSON.stringify({ tableId, updatedAt: Date.now(), shownItemIds }));
};
